import { createStore, applyMiddleware, compose } from 'redux';
import Immutable from 'immutable';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunkMiddleware from 'redux-thunk';
import { persistReducer, persistStore } from 'redux-persist';
import immutableTransform from 'redux-persist-transform-immutable';
import storage from 'redux-persist/lib/storage';
import { isProduction } from '../config';
import STORAGE_KEY from '../constants/LocalStoragePersistKey';
import { RESET_APPLICATION } from './modules/authentication';
import appReducer from './modules/reducer';
import userMiddleware from './middleware/user';
import errorMiddleware from './middleware/error';
import systemMiddleware from './middleware/system';
import billingMiddleware from './middleware/billing';
import documentsMiddleware from './middleware/documents';
import analyticsMiddleware from './middleware/analytics';

export default preloadedState => {
  const middlewareEnhancer = applyMiddleware(
    thunkMiddleware,
    errorMiddleware,
    userMiddleware,
    systemMiddleware,
    billingMiddleware,
    analyticsMiddleware,
    documentsMiddleware,
  );

  let composedEnhancers;
  if (isProduction) {
    composedEnhancers = compose(middlewareEnhancer);
  } else {
    composedEnhancers = composeWithDevTools(middlewareEnhancer);
  }

  const rootReducer = (state, action) => {
    if (action.type === RESET_APPLICATION) {
      return appReducer(undefined, action);
    }

    return appReducer(state, action);
  };

  const persistConfig = {
    transforms: [immutableTransform()],
    key: STORAGE_KEY,
    storage,
    whitelist: ['authentication', 'app'],
  };

  const persistedReducer = persistReducer(persistConfig, rootReducer);

  const store = createStore(
    persistedReducer,
    Object.keys(preloadedState || {}).reduce((acc, cur) => {
      acc[cur] = Immutable.fromJS(preloadedState[cur]);
      return acc;
    }, {}),
    composedEnhancers,
  );

  persistStore(store);

  return store;
};
